import Vue from "vue";
import App from "./App.vue";
import VModal from 'vue-js-modal'
import "@/styles/_reset.css";
import smoothscroll from "smoothscroll-polyfill";

import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/functions";

smoothscroll.polyfill();
Vue.config.productionTip = false;
Vue.use(VModal);

export const competition = "covve-comp-420";
export const FAKE_EMAIL_DOMAIN = '@covvesnakefake.com';

const config = {
  apiKey: "AIzaSyA1DyIAiVPtqjGKz957GSPc-5y0HpKkWgw",
  authDomain: "covve-snake-comp-420.web.app",
  databaseURL: "https://covve-snake.firebaseio.com",
  projectId: "covve-snake",
  storageBucket: "covve-snake.appspot.com",
  messagingSenderId: "133116654479"
};
firebase.initializeApp(config);

export const db = firebase
  .firestore()
  .collection("competitions")
  .doc(competition);

export const auth = firebase.auth();

export const functions = firebase.app().functions("europe-west1");
// export const functions = firebase.app().functions();
// functions.useFunctionsEmulator("http://localhost:5001");

new Vue({
  render: h => h(App)
}).$mount("#app");